import { default as React } from "react"
import { StaticImage } from "gatsby-plugin-image"
import { v4 as uuidv4 } from "uuid"

const getColor = score => {
  if (score < 2) {
    return "h-full bg-red-600"
  }
  if (score < 3.75) {
    return "h-full bg-yellow-400"
  } else {
    return "h-full bg-green-600"
  }
}

const getStars = score => {
  const scoreSplit = (score + "").split(".")
  let length = scoreSplit[0]
  if (scoreSplit[1] === "5") {
    length++
  }
  return Array.from({ length: length }, (_, index) =>
    index === length - 1 && scoreSplit[1] === "5" ? "H" : "F"
  )
}

const Score = props => {
  return (
    <div className="w-full">
      {props.beer && (
        <div className="inline-block text-xl font-bold">
          <div>{props.score}</div>
          <div className="h-1 w-40 bg-gray-300 mx-4 mb-4">
            <div
              style={{ width: `${(props.score / 5) * 100}%` }}
              className={getColor(props.score)}
            ></div>
          </div>
        </div>
      )}
      {!props.beer && (
        <div className="mx-auto">
          {getStars(props.score).map(star => {
            if (star === "F") {
              return (
                <StaticImage
                  key={uuidv4()}
                  id="fullStar"
                  className="inline-flex md:w-6 w-4 mb-1 my-0 mx-auto text-center"
                  src="../images/star.png"
                  alt="ff words logo"
                  layout="fullWidth"
                  loading="eager"
                />
              )
            } else {
              return (
                <StaticImage
                  key={uuidv4()}
                  id="halfStar"
                  className="inline-flex md:w-6 w-4 mb-1 my-0 mx-auto text-center"
                  src="../images/halfstar.png"
                  alt="ff words logo"
                  layout="fullWidth"
                  loading="eager"
                />
              )
            }
          })}
        </div>
      )}
    </div>
  )
}

export default Score
